module.exports = __webpack_public_path__ + "img/menu-icon-blue.7471a62f.svg";